// eslint-disable-next-line @nx/enforce-module-boundaries
import { CHK_TOAST_VARIANT } from '@ui/checkout-components';

export const TOAST_VARIANT = CHK_TOAST_VARIANT;
